export async function tourAccommodationMap(accommodations) {
    const {$api} = useNuxtApp()

    const getLocation = async cityId => {
        try {
            const {
                cities: [city],
            } = await $api.locations.get({id: cityId, limit: 1})
            return `${city.name}, ${city.countryName}`
        } catch (e) {
            console.error(`Failed to fetch location for cityId: ${cityId}`, e)
            return null
        }
    }

    const getHotel = async hotelId => {
        try {
            const {
                hotels: [hotel],
            } = await $api.hotels.getFull({
                hotelId,
                contentProviderId: 1,
                limit: 1,
            })
            return hotel
        } catch (e) {
            console.error(`Failed to fetch hotel info for hotelId: ${hotelId}`, e)
            return null
        }
    }

    const getCategory = async id => {
        try {
            const {
                categories: [category],
            } = await $api.ownProductServiceCategories.get({
                id,
            })
            return category
        } catch (e) {
            console.error(`Failed to fetch category info for categoryId: ${id}`, e)
            return null
        }
    }

    return await Promise.all(
        accommodations.map(async accommodation => {
            let cityId = null
            let categoryToHotel = []

            if (accommodation?.cityId) {
                cityId = await getLocation(accommodation?.cityId)
            }

            const result = Object.entries(accommodation.categoryToHotel).map(([categoryId, hotelId]) => ({
                categoryId,
                hotelId,
            }))
            categoryToHotel = await Promise.all(
                result.map(async item => {
                    try {
                        let hotelInf = await getHotel(item.hotelId)
                        let categoryInf = await getCategory(item.categoryId)

                        return {
                            hotelInf,
                            categoryInf,
                        }
                    } catch (error) {
                        console.error(`Failed to process item: ${JSON.stringify(item)}`, error)
                        return {
                            hotelInf: null,
                            categoryInf: null,
                        }
                    }
                })
            )

            return {
                ...accommodation,
                cityId,
                categoryToHotel,
            }
        })
    )
}
